import { TitleProps } from "@refinedev/core";
import { Link } from "react-router-dom";
import React from "react";

export const Title: React.FC<TitleProps> = ({ collapsed }) => (
  <Link to="/" style={{ textDecoration: "none" }}>
    {collapsed ? (
      <img
        src={"/emariner-logo-collapsed.png"}
        alt="eMariner Admin"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "12px 12px",
          width: "72px",
          height: "70px",
        }}
      />
    ) : (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          padding: "16px 20px",
        }}
      >
        <img
          src={"/emariner-logo-collapsed.png"}
          alt="eMariner"
          style={{
            width: "44px",
            height: "44px",
          }}
        />
        <div style={{ display: "flex", flexDirection: "column" }}>
          <span
            style={{
              color: "#ffffff",
              fontSize: "16px",
              fontWeight: 600,
              letterSpacing: "-0.02em",
              lineHeight: 1.2,
            }}
          >
            eMariner
          </span>
          <span
            style={{
              color: "rgba(255, 255, 255, 0.6)",
              fontSize: "11px",
              fontWeight: 500,
              textTransform: "uppercase",
              letterSpacing: "0.05em",
            }}
          >
            Admin Portal
          </span>
        </div>
      </div>
    )}
  </Link>
);
